module.exports = __webpack_public_path__ + "static/media/Tornax-RG-3200-TILE.bdc60196.png";